<div id="loadingMsg" class="">
  <h1>LOADING...</h1>
</div>
<br>
<br>

<div class="container main-content pt-5 col-lg-10 col-12">
  <div class="custom-card mx-auto" style="max-width: 50rem; align-items: center;">
    <div class="row align-items-center mb-3 justify-content-between">
      <h2 class="custom-card-title">Create a New User</h2>
      <div id="signUpForm" class="fixed loginCard hidden">
        <form [formGroup]="createForm">
          <div id="nameBar">
            <div class="row g-1 mb-2">
              <div class="titles col-2">
                <select class="form-select" name="title" id="title" formControlName="title">
                  <option value="">Title</option>
                  <option value="Mr.">Mrs.</option>
                  <option value="Ms.">Ms.</option>
                  <option value="Mr.">Mr.</option>
                  <option value="Dr.">Dr.</option>
                  <option value=" ">&nbsp;</option>
                </select>
              </div>
              <div class="col-4"> <input class="form-control" type="name" placeholder="First Name" formControlName="firstName"></div>
              <div class="col-2"><input class="form-control" type="text" placeholder="M.I." formControlName="middleInit" id="middle" maxlength="1"></div>
              <div class="col-4"> <input class="form-control" type="name" placeholder="Last Name" formControlName="lastName"></div>
            </div>

          </div>
          <div id="roles" class="mb-2">
            <select name="role" id="role" formControlName="role" class="form-select">
              <option value="" disabled>Role</option>
              <option value="{{role}}" *ngFor="let role of roles">{{role}}</option>
            </select>
          </div>

          <div id="schoolBar">
            <div class="row g-1 mb-2">
              <div class="col-3">  <div class="grades">
                <select name="grades" id="grades" formControlName="grade" class="form-select">
                  <option value="">Grades</option>
                  <option value="{{grade}}" *ngFor="let grade of grades">{{grade}}</option>
                </select>
              </div></div>
              <div class="col-9"> <div class="school">
                <select name="schools" id="schools" formControlName="school" class="form-select">
                  <option value="">School</option>
                  <option value="All Schools">All Schools</option>
                  <option value="{{school.name}}" *ngFor="let school of schools">{{school.name}}</option>
                </select>
              </div> </div>
            </div>
          </div>

          <div id="emailBar" class="mb-2">
            <input type="email" placeholder="Email" formControlName="email" class="form-control">
          </div>

          <div id="buttonCont">
            <button type="submit" class="btn btn-primary me-2" (click)="createUser()">SUBMIT</button>
            <a class="btn btn-secondary" routerLink="/profile">CANCEL</a>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<br>
<br>
